import { css } from '@flipster/styled-system/css';

export const spacing3 = 8;
export const spacing6 = 16;
export const spacing7 = 20;
export const spacing8 = 24;
export const spacing9 = 32;
export const spacing10 = 40;
export const spacing11 = 48;
export const spacing13 = 80;

export const sectionInnerLayoutCssRaw = css.raw({
  px: spacing6,
  py: { base: spacing11, tablet: spacing13 },
  boxSizing: 'content-box',
  tablet: {
    maxWidth: 'desktopMaxWidth',
    mx: 'auto',
  },
});
